import { mutationTree } from 'typed-vuex';
import initialState from './state';

const mutations = mutationTree(initialState, {
  SHOW_SPINNER(state) {
    state.loading = true;
  },

  HIDE_SPINNER(state) {
    state.loading = false;
  },

  TOGGLE_DRAWER(state, payload: boolean) {
    state.showDrawer = payload;
  },

  ADD_ERROR_MSG(state, errorMsgKey: string) {
    state.errorMsgKeys.unshift(errorMsgKey);
  },

  REMOVE_ERROR_MSG(state, errorMsgIndex: number) {
    if (errorMsgIndex >= 0) {
      state.errorMsgKeys.splice(errorMsgIndex, 1);
    }
  },

  ADD_SEARCH_INPUT(state, payload: string) {
    state.searchInput = payload;
  },
});

export default mutations;
